/* eslint-disable prefer-arrow-callback */
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useWindowWidth } from '@react-hook/window-size';

export const TabBar = React.forwardRef(
  function TabBar({
    children,
    className,
    ...props
  }, ref) {
    return (
      <div ref={ref} className={clsx(className, 'ss_tab-bar')} {...props}>
        {children}
      </div>
    );
  },
);

TabBar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

TabBar.defaultProps = {
  className: undefined,
};

export const TabItem = React.forwardRef(
  function TabItem({ className, active, ...props }, ref) {
    return (
      <div ref={ref} className={clsx(className, 'ss_tab-item', active && 'ss_active')} {...props} />
    );
  },
);

TabItem.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

TabItem.defaultProps = {
  active: false,
  className: undefined,
};

export const TabCarousel = ({ selectedId, tabContent, onTabClick }) => {
  const tabBarRef = useRef();
  const tabItemRefs = useRef({});
  const windowWidth = useWindowWidth(500);

  useEffect(() => {
    const id = selectedId;
    const tabWidth = tabItemRefs.current[id].offsetWidth / 2;
    const winWidth = window.innerWidth / 2;
    tabBarRef.current.scrollLeft = tabItemRefs.current[id].offsetLeft - winWidth + tabWidth;
  }, [selectedId, windowWidth]);

  return (
    <TabBar ref={tabBarRef}>
      {
        tabContent.map(({ id, name }) => (
          <TabItem
            active={id === selectedId}
            onClick={() => onTabClick(id)}
            key={id}
            ref={(elRef) => { tabItemRefs.current[id] = elRef; }}
          >
            {name}
          </TabItem>
        ))
      }
    </TabBar>
  );
};

TabCarousel.propTypes = {
  selectedId: PropTypes.string.isRequired,
  tabContent: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string, name: PropTypes.string }),
  ).isRequired,
  onTabClick: PropTypes.func.isRequired,
};
